module.exports = __webpack_public_path__ + "static/img/birds.eee0b15.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/birds.svg
// module id = iA2p
// module chunks = 0